<div class="e11-min-h-full-full e11-bg-skin-app-bg">
  <router-outlet></router-outlet>
</div>
